<template>
  <div class="popUpBody" @focus="alert('focus')">
    <div class="modal-header modal-header-popup">
      <strong>
        <slot name="header"></slot>
      </strong>
      <div>
        <b-button v-if="geometry" class="c-pointer p-0 pr-2" variant="transparent" @click.prevent="copyPosition()"
          title="Copiar a posição do elemento no formato Google">
          <i class="fa fa-copy" aria-hidden="true"></i>
        </b-button>

        <b-button class="c-pointer p-0" variant="transparent" @click.prevent="exit()" size="lg" title="Fechar">
          <i class="fa fa-times" style="color: #000;" aria-hidden="true" title="Fechar"></i>
        </b-button>
      </div>
    </div>
    <overlay :show="this.$store.getters.isLoading">
      <div class="modal-body" :class="{ 'modal-body-full': fullScreen }">
        <slot name="body"></slot>
        <div class="alert-message pt-3" v-if="showMessage">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Campos em vermelho são obrigatórios.
        </div>
      </div>

      <div class="modal-footer" v-if="$slots.button || $slots.legend">
        <div class="footer-slot">
          <slot name="legend"></slot>
        </div>
        <div class="footer-button-container">
          <slot name="button"></slot>
        </div>
      </div>
    </overlay>

  </div>
</template>

<script>
import Overlay from "@/components/extra/Overlay.vue";
import {
  closePopupBus,
  sucessMessage,
  errorMessage,
} from "../components/MessageBus";

export default {
  name: "TemplatePopup",
  props: ["showMessage", "fullScreen", "disableMapButton", "geometry", "componentId"],
  data() {
    return {
      internalComponentId: null,
    };
  },
  computed: {
    effectiveComponentId() {
      return this.componentId || this.internalComponentId;
    },
  },
  mounted() {
    if (!this.componentId) {
      let ancestor = this.$parent;
      while (ancestor) {
        if (ancestor.componentId !== undefined && ancestor.componentId !== null) {
          this.internalComponentId = ancestor.componentId;
          break;
        }
        if (ancestor.$attrs && ancestor.$attrs.componentId !== undefined && ancestor.$attrs.componentId !== null) {
          this.internalComponentId = ancestor.$attrs.componentId;
          break;
        }
        if (ancestor.$vnode && ancestor.$vnode.data && ancestor.$vnode.data.attrs && ancestor.$vnode.data.attrs.componentId !== undefined && ancestor.$vnode.data.attrs.componentId !== null) {
          this.internalComponentId = ancestor.$vnode.data.attrs.componentId;
          break;
        }
        ancestor = ancestor.$parent;
      }
    }
  },
  components: {
    Overlay,
  },
  methods: {
    copyPosition() {
      if (this.geometry && this.geometry.coordinates)
        navigator.clipboard
          .writeText(
            `http://maps.google.com/?q=${this.geometry.coordinates[1]},${this.geometry.coordinates[0]}`
          )
          .then(
            () => {
              sucessMessage("Posição do elemento foi copiado para memória");
            },
            () => {
              errorMessage(
                "Não foi possível copiar a posição do elemento, entre em contato com o suporte."
              );
            }
          );
    },
    exit() {
      closePopupBus(this.effectiveComponentId);
    },
  },
};
</script>

<style scoped>
/* =====================================================
   POPUP – ajustes completos (somente CSS)
   ===================================================== */

.popUpBody {
  --safe-bottom: env(safe-area-inset-bottom, 0px);
  --footer-h: 72px;
  /* --gap-x: 16px; */
  /* --gap-y: 12px; */
  --border: #e5e7eb;
  --bg: #fff;
}

.popUpBody {
  max-height: 100dvh;
  overflow: hidden;
  background: var(--bg);
  border: 1px solid var(--border);
  /* border-radius: 12px; */
  display: flex;
  flex-direction: column;
}

/* When the popup is rendered inside the left/right/full modal containers
   we need the popup body to fill the available viewport height so the
   footer stays stuck to the bottom and the body becomes scrollable. */
/* ensure box-sizing so padding/border are counted in height calculations */
.popUpBody,
.modal-body {
  box-sizing: border-box;
}

.modal-dialog-right .popUpBody,
.modal-dialog-left .popUpBody {
  /* account for the top offset used by the container (61px)
     use dynamic viewport units (dVh) to avoid mobile browser chrome gaps */
  height: calc(100dvh - 61px);
  max-height: calc(100dvh - 61px);
  min-height: 0;
  border-radius: 0;
  display: flex;
  flex-direction: column;
}

.modal-dialog-full .popUpBody {
  height: 100dvh;
  max-height: 100dvh;
  min-height: 0;
  border-radius: 0;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-header-popup {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 48px;
  padding: 5px 7px;
  background: var(--bg);
  border-bottom: 1px solid var(--border);
}

.modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 12px 14px;
}

.modal-footer {
  flex: 0 0 auto;
  background: var(--bg);
  border-top: 1px solid var(--border);
  padding: 12px var(--gap-x);
  padding-bottom: calc(12px + var(--safe-bottom));
  min-height: calc(var(--footer-h) + var(--safe-bottom));
  display: flex;
  flex-direction: column;
  gap: var(--gap-y);
}

.footer-slot {
  flex: 0 0 auto;
}

.footer-button-container {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: var(--gap-y) var(--gap-x);
}

.footer-button-container .action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  line-height: 1.1;
  padding: 8px 10px;
  border-radius: 10px;
  transition: transform .12s ease, background .12s ease;
  user-select: none;
}

.footer-button-container .action:hover {
  background: #f7f7f8;
}

.footer-button-container .action:active {
  transform: scale(.98);
}

.footer-button-container .action[disabled],
.footer-button-container .action.is-disabled {
  opacity: .5;
  pointer-events: none;
}

@media (max-width: 640px) {
  .popUpBody {
    height: 100dvh;
    max-height: 100dvh;
  }

  .footer-button-container .action {
    flex-direction: column;
    gap: 6px;
    padding: 10px 6px;
  }
}

@media only screen and (max-width: 576px) and (orientation: portrait) {
  .modal-dialog-right .popUpBody,
  .modal-dialog-left .popUpBody,
  .modal-dialog-middle .popUpBody {
    height: calc(100dvh - 96px);
  }
}

@media only screen and (max-height: 576px) and (orientation: landscape) {
  .modal-dialog-right .popUpBody,
  .modal-dialog-left .popUpBody,
  .modal-dialog-middle .popUpBody {
    height: calc(100dvh - 61px);
  }
}


/* iOS específico - quando há safe area */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  @media (max-width: 640px) {
    .popUpBody {
      height: 100dvh;
      max-height: 100dvh;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .footer-button-container .action {
    transition: none;
  }
}
</style>
